import createIsPristine from './selectors/isPristine';
import plain from './structure/plain';
export default createIsPristine(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/isPristine.js
// module id = 1057
// module chunks = 0